import {
  APP_INITIALIZER,
  ApplicationConfig,
  ErrorHandler,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection
} from '@angular/core';
import {provideRouter} from '@angular/router';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {authTokenInterceptor} from './core/interceptors/auth-token.interceptor';
import {apiErrorsInterceptor} from './core/interceptors/api-errors.interceptor';
import {unauthorizedInterceptor} from './core/interceptors/unauthorized.interceptor';
import * as Sentry from "@sentry/angular";
import {Router} from '@angular/router';
import {routes} from './app.routes';
import {environment} from '../environments/environment';
import {AppErrorHandler} from './core/error-handler/app-error.handler';
import {hoomvipRequestCountInterceptor} from './core/interceptors/hoomvip-request-count.interceptor';
import {BrandingNavigationInterceptor} from './core/interceptors/branding-navigation.interceptor';

const httpInterceptors = [
  authTokenInterceptor,
  apiErrorsInterceptor,
  unauthorizedInterceptor,
  ...(environment.debug ? [hoomvipRequestCountInterceptor] : []),
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    provideHttpClient(withInterceptors(httpInterceptors)),
    {
      provide: ErrorHandler,
      useClass: AppErrorHandler,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (brandingNavigationInterceptor: BrandingNavigationInterceptor) => () => {
        brandingNavigationInterceptor.init();
      },
      deps: [BrandingNavigationInterceptor],
      multi: true,
    },
    ...(environment.sentryActive
      ? [
        {
          provide: Sentry.TraceService,
          deps: [Router],
        },
        {
          provide: APP_INITIALIZER,
          useFactory: () => () => {
          },
          deps: [Sentry.TraceService],
          multi: true,
        },
      ]
      : []),
  ]
};
